import { ORDER_INQUIRY_KIND_LABELS, ORDER_INQUIRY_KINDS } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { FilterSelect } from '@/shared/ui';

interface OrderInquiryListFiltersProps {
  readonly status: string;
  readonly kind: string;
  readonly onStatusChange: (value: string) => void;
  readonly onKindChange: (value: string) => void;
}

/** 문의 목록 필터 — 상태(기본 처리 중)·종류. */
export const OrderInquiryListFilters = ({
  status,
  kind,
  onStatusChange,
  onKindChange,
}: OrderInquiryListFiltersProps): ReactElement => (
  <div className="flex flex-wrap items-center gap-2">
    <FilterSelect
      aria-label="상태 필터"
      value={status}
      onChange={(e) => onStatusChange(e.target.value)}
    >
      <option value="OPEN">처리 중</option>
      <option value="ANSWERED">답변 완료</option>
      <option value="">전체</option>
    </FilterSelect>
    <FilterSelect
      aria-label="종류 필터"
      value={kind}
      onChange={(e) => onKindChange(e.target.value)}
    >
      <option value="">전체</option>
      {ORDER_INQUIRY_KINDS.map((value) => (
        <option key={value} value={value}>
          {ORDER_INQUIRY_KIND_LABELS[value]}
        </option>
      ))}
    </FilterSelect>
  </div>
);
